module.exports = __webpack_public_path__ + "img/front.cc4c8f44.jpg";